module.exports = __webpack_public_path__ + "static/media/FundTransfer.04565555.svg";